import React from 'react';

import { bigHoverActionContainer } from './BigHoverAction.scss';

export default function BigHoverActionPlaceholder() {
    return <div className={bigHoverActionContainer}></div>;
}
